/*
 * @providesModule CurrencyString
 */
// @ts-nocheck
import React from 'react';

import GradientLabel from 'GradientLabel';
import Label from 'Label';
import {_m} from 'INTL';
import PropTypes from 'prop-types';
import SkillzStyle from 'SkillzStyle';
import SkillzImage from 'SkillzImage';
import SKZStyleSheet from 'SKZStyleSheet';
import {Optional} from 'Optional';
import Sizes from 'Sizes';

import {StyleSheet, View} from 'react-native';

const {fontRegular} = SkillzStyle.fullStyles;

export default class CurrencyString extends React.PureComponent {
  static propTypes = {
    amount: PropTypes.any,
    currencyString: PropTypes.string,
    isVirtual: PropTypes.bool,
    isTicketzTournament: PropTypes.bool,
    isGradient: PropTypes.bool,
    otherStakesCount: PropTypes.number,
    isPooledLiquidity: PropTypes.bool,
    isMatchSelectCell: PropTypes.bool,
    isCentered: PropTypes.bool,
    largeCurrencyIcon: PropTypes.bool,
    currencyIcon: PropTypes.string,
    ticketzCurrencyIcon: PropTypes.string,
  };

  static defaultProps = {
    isMatchSelectCell: false,
    otherStakesCount: 0,
    ticketzImageSource: 'ic_ticketz_background.png',
  };

  _textComponentForStylesProvided() {
    if (this.props.isGradient) {
      return GradientLabel;
    } else {
      return Label;
    }
  }

  _practiceCurrencyIconStyle() {
    let size = 32;
    if (this.props.isCentered) {
      return [this.props.style, styles.currency, {height: size, width: size, paddingBottom: 5}];
    }
    if (!this.props.largeCurrencyIcon) {
      size = size / 2;
    } else {
      size = size - 2;
    }

    return [this.props.style, {height: size, width: size}];
  }

  _practiceCurrencyIconTextStyle() {
    if (this.props.isCentered) {
      return [this.props.style, styles.currency, {fontSize: 15, paddingBottom: 5}];
    }
    let fontSize = SKZStyleSheet.filterFromStyle(this.props.style)['fontSize'];
    if (!this.props.largeCurrencyIcon) {
      fontSize = fontSize / 2;
    } else {
      fontSize = fontSize - 2;
    }
    return [this.props.style, {fontSize: fontSize}];
  }

  _getConditionalStyling() {
    let conditionalStyling = {};

    if (this.props.otherStakesCount > 0) {
      conditionalStyling = {
        paddingBottom: 10,
      };
    }

    return conditionalStyling;
  }

  _renderVirtualCurrency(): React.ReactNode {
    //Render both z coin and z amount
    const TextComponent = this._textComponentForStylesProvided();
    const style = this.props.currencyIcon
      ? this._practiceCurrencyIconStyle()
      : this._practiceCurrencyIconTextStyle();

    let coin = undefined;
    if (this.props.currencyIcon) {
      coin = (
        <SkillzImage
          style={[style]}
          resizeMode={this.props.resizeMode || 'contain'}
          source={this.props.currencyIcon}
        />
      );
    } else {
      coin = (
        <TextComponent style={[style]} adjustsFontSizeToFit={true} numberOfLines={1}>
          {SkillzStyle.currencyValues.practiceCurrencyString}
        </TextComponent>
      );
    }

    const text = (
      <TextComponent style={[this.props.style]} adjustsFontSizeToFit={true} numberOfLines={1}>
        {this.props.amount.toString()}
      </TextComponent>
    );

    return (
      <View style={[styles.virtualCurrencyContainer, this._getConditionalStyling()]}>
        {coin}
        {text}
      </View>
    );
  }

  _renderCashCurrency(): React.ReactNode {
    const TextComponent = this._textComponentForStylesProvided();
    const conditionalStyling = this._getConditionalStyling();

    if (this.props.isPooledLiquidity && this.props.isMatchSelectCell) {
      return <TextComponent style={[this.props.style, conditionalStyling]}>{'?'}</TextComponent>;
    }

    return (
      <TextComponent style={[this.props.style, conditionalStyling]}>
        {this.props.amount}
      </TextComponent>
    );
  }

  _renderTicketzCurrency(): React.ReactNode {
    const TextComponent = this._textComponentForStylesProvided();
    const size = Sizes.isTablet() ? 32 : 16;
    let coin = undefined;
    if (this.props.ticketzCurrencyIcon) {
      coin = (
        <SkillzImage
          style={{height: size, width: size}}
          resizeMode={this.props.resizeMode || 'contain'}
          source={this.props.ticketzCurrencyIcon}
        />
      );
    }

    const text = (
      <TextComponent style={[this.props.style]} adjustsFontSizeToFit={true} numberOfLines={1}>
        {this.props.amount.toString()}
      </TextComponent>
    );

    return (
      <View style={[styles.virtualCurrencyContainer, this._getConditionalStyling()]}>
        <Optional test={this.props.ticketzCurrencyIcon}>{coin}</Optional>
        {text}
      </View>
    );
  }

  _renderCurrency(): React.ReactNode {
    if (this.props.isVirtual) {
      return this._renderVirtualCurrency();
    }
    if (this.props.isTicketzTournament) {
      return this._renderTicketzCurrency();
    }
    return this._renderCashCurrency();
  }

  _renderOtherStakes(): React.ReactNode {
    const otherStakesString = _m('+{0} more', this.props.otherStakesCount.toString());
    const TextComponent = this._textComponentForStylesProvided();
    const color = StyleSheet.flatten(this.props.style).color;
    return (
      <TextComponent
        style={[styles.otherStakes, {color: color}]}
        adjustsFontSizeToFit={true}
        numberOfLines={1}
      >
        {otherStakesString}
      </TextComponent>
    );
  }

  render(): React.ReactNode {
    if (this.props.otherStakesCount <= 0) {
      return this._renderCurrency();
    }
    return (
      <View>
        {this._renderCurrency()}
        {this._renderOtherStakes()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
  },

  currency: {
    marginTop: 12,
    marginBottom: 4,
  },

  virtualCurrencyContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 5,
  },

  currencyContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  otherStakes: {
    ...fontRegular,
    height: 15,
    bottom: 10,
    textAlign: 'center',
  },
});
